const ss = window.sessionStorage
const ls = window.localStorage

export const language = {
  get () {
    return ls.getItem('language')
  },
  set (language) {
    ls.setItem('language', language)
  }
}

export const locale = {
  get () {
    return ls.getItem('locale')
  },
  set (locale) {
    ls.setItem('locale', locale)
  }
}

export const resource = {
  get () {
    const resource = ss.getItem('resource')
    return resource ? JSON.parse(resource) : undefined
  },
  set (resource) {
    ss.setItem('resource', JSON.stringify(resource))
  }
}

export const domainSettings = {
  get () {
    const domainSettings = ss.getItem('domainSettings')
    return domainSettings ? JSON.parse(domainSettings) : {}
  },
  set (domainSettings) {
    ss.setItem('domainSettings', JSON.stringify(domainSettings))
  }
}

export const user = {
  get () {
    const user = ss.getItem('user')
    return user ? JSON.parse(user) : undefined
  },
  set (user) {
    ss.setItem('user', JSON.stringify(user))
  }
}

export const subscriptionId = {
  get () {
    const subscriptionId = ss.getItem('subscriptionId')
    return subscriptionId ? Number.parseInt(subscriptionId) : 0
  },
  set (subscriptionId) {
    ss.setItem('subscriptionId', subscriptionId)
  }
}

export const appThemes = {
  get () {
    const appThemes = ss.getItem('appThemes')
    return appThemes ? JSON.parse(appThemes) : []
  },
  set (appThemes) {
    ss.setItem('appThemes', JSON.stringify(appThemes))
  }
}

export const themesBackgroundColors = {
  get () {
    const themesBackgroundColors = ss.getItem('themesBackgroundColors')
    return themesBackgroundColors ? JSON.parse(themesBackgroundColors) : []
  },
  set (themesBackgroundColors) {
    ss.setItem('themesBackgroundColors', JSON.stringify(themesBackgroundColors))
  }
}

export const textureImages = {
  get () {
    const textureImages = ss.getItem('textureImages')
    return textureImages ? JSON.parse(textureImages) : []
  },
  set (textureImages) {
    ss.setItem('textureImages', JSON.stringify(textureImages))
  }
}

export const fonts = {
  get () {
    const fonts = ss.getItem('fonts')
    return fonts ? JSON.parse(fonts) : []
  },
  set (fonts) {
    ss.setItem('fonts', JSON.stringify(fonts))
  }
}

export const activeDevice = {
  get () {
    return ls.getItem('activeDevice')
  },
  set (activeDevice) {
    ls.setItem('activeDevice', activeDevice)
  }
}

export const systemSubscriptionModules = {
  get () {
    const systemSubscriptionModules = ss.getItem('systemSubscriptionModules')
    return systemSubscriptionModules ? JSON.parse(systemSubscriptionModules) : []
  },
  set (systemSubscriptionModules) {
    ss.setItem('systemSubscriptionModules', JSON.stringify(systemSubscriptionModules))
  }
}
export const AppSelectedTemplate = {
  get () {
    const AppSelectedTemplate = ss.getItem('AppSelectedTemplate')
    return AppSelectedTemplate ? JSON.parse(AppSelectedTemplate) : []
  },
  set (AppSelectedTemplate) {
    ss.setItem('AppSelectedTemplate', JSON.stringify(AppSelectedTemplate))
  }
}



// WEBPACK FOOTER //
// ./src/modules/storage/index.js